import {
  getUserProfileRequest,
  getUserProfileSuccess,
  getUserProfileFailed,
  updateUserProfileRequest,
  updateUserProfileSuccess,
  updateUserProfileFailed,
  changePasswordRequest,
  changePasswordSuccess,
  changePasswordFailed,
} from "./reducer";
import {
  getCurrentUser,
  updateCurrentUser,
  changeUserPassword,
} from "../../helpers/profile_helper";
import {authUserManager} from "../../helpers/api_helper";

/**
 * Pobierz profil aktualnego użytkownika
 */
export const getUserProfile = (userId) => async (dispatch) => {
  try {
    dispatch(getUserProfileRequest());
    const response = await getCurrentUser(userId);
    dispatch(getUserProfileSuccess(response));
  } catch (error) {
    console.log(error);
    const errorMessage =
      error.response?.data?.detail ||
      error.response?.data?.message ||
      error.message ||
      "Failed to load profile";
    dispatch(getUserProfileFailed(errorMessage));
  }
};

/**
 * Aktualizuj profil użytkownika
 */
export const updateUserProfile = (userId, profileData) => async (dispatch) => {
  try {
    dispatch(updateUserProfileRequest());
    const response = await updateCurrentUser(userId, profileData);
    dispatch(updateUserProfileSuccess(response));
    if (profileData.username) {
      authUserManager.updateUsername(profileData.username);
    }
  } catch (error) {

    dispatch(updateUserProfileFailed(error));
  }
};

/**
 * Zmień hasło użytkownika
 */
export const changePassword = (userId, passwordData) => async (dispatch) => {
  try {
    dispatch(changePasswordRequest());
    await changeUserPassword(userId, passwordData);
    dispatch(changePasswordSuccess());
  } catch (error) {
    dispatch(changePasswordFailed(error));
  }
};

export { resetProfileFlags } from "./reducer";
